interface Props {
    shot: any;
    includeDescription?: boolean;
    includeShotSize?: boolean;
    includeLensFocalLength?: boolean;
    includeNotes?: boolean;
    includeCharacters?: boolean;
    includeMovement?: boolean;
    className?: string;
}

const ShotMeta = ({
    shot,
    includeDescription,
    includeShotSize,
    includeLensFocalLength,
    includeNotes,
    includeCharacters,
    includeMovement,
    className
}: Props) => {
    return (
        <div className={"shot-meta" + (className ? ` ${className}` : "")}>
            {includeDescription && shot.description && <div className="meta-row"><span className="shot-meta-label">Description:</span> {shot.description}</div>}
            {includeShotSize && shot.shotSizeDescription && <div className="meta-row"><span className="shot-meta-label">Size:</span> {shot.shotSizeDescription}</div>}
            {includeLensFocalLength && shot.lensFocalLength && <div className="meta-row"><span className="shot-meta-label">Lens:</span> {shot.lensFocalLength}mm</div>}
            {includeCharacters && shot.characters?.length > 0 && <div className="meta-row"><span className="shot-meta-label">Characters:</span> {(shot.characters || []).join(', ')}</div>}
            {includeMovement && shot.movementDescriptions && <div className="meta-row"><span className="shot-meta-label">Movement:</span> {shot.movementDescriptions}</div>}
            {includeNotes && <div className="meta-row"><span className="shot-meta-label">Notes:</span> {shot.notes || ''}</div>}
        </div>
    );
};

export default ShotMeta;
